import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'proffeo-cooperations',
  template: '<router-outlet></router-outlet>',
  imports: [RouterModule]
})
export class CooperationsComponent {}
